import { ClaimPropertyStatusEnum } from '../enums/claim-property-status.enum';
import { ClaimValuesTypesEnum } from '../pages/claim_estates/enums/ClaimValues.enum';
import { get, post, put, remove } from './request';
import { ClaimCondominiumType } from '../pages/claim_estates/types/ClaimCondominiumTypes';

type ClaimEstateDTO = {
  id?: string;
  status?: string;
  observations?: string;
  responsibleId: string | null;
  estateResponsibleId?: string | null;
  createdBy?: string;
  insurerId?: string | null;
  estateId: string;
  bondInsuranceHiredData?: string;
  policyNumber: string | null;
  processNumber?: string | null;
  claimCode?: string | null;
  returnFollowup?: number;
  notificationEmails?: string[] | string;
  propertyPublicId?: string;
  productType?: string;
  eventDate?: string | null;
  eventTime?: string | null;
  eventDescription?: string | null;
  coverages?: string[];
  insuranceBroker?: string;
  insuranceStatus?: string;
  insuranceExpirationDate?: string | null;
};

type ClaimPropertyDTO = {
  id?: string;
  country: string;
  state: string;
  city: string;
  district: string;
  street: string;
  number: string;
  complement: string;
  propertyCode?: string | null;
  zipCode: string;
  deliveryKeysDate?: string;
  status: ClaimPropertyStatusEnum;
};

type ClaimTenantDTO = {
  id?: string;
  document?: string;
  fullName: string;
  email: string;
  cellphone: string;
};

export type ClaimCondominiumDTO = {
  id?: string;
  document: string;
  legalName: string;
  email: string;
  phone: string;
  responsibleName?: string | null;
  responsibleEmail?: string | null;
  responsiblePhone?: string | null;
};

export type LookupClaimCondominiumResponse = {
  data: (ClaimCondominiumDTO & {
    estate?: {
      id: string;
      name?: string;
    };
    propertyPublicId?: string;
    identification?: string;
    address?: {
      zipcode?: string;
      street?: string;
      neighborhood?: string;
      number?: string;
      complement?: string;
      city?: string;
      state?: string;
    };
  }) | null;
};

type ClaimValueDTO = {
  id?: string;
  dueDate: Date;
  value: number;
  totalInstallments?: number;
  numberInstallment?: number;
  valueType: ClaimValuesTypesEnum;
  claimEstateId?: string;
  paintingArea?: number;
};

export type claimSubmitProps = {
  claimEstate: ClaimEstateDTO;
  claimProperty: ClaimPropertyDTO;
  claimTenant: ClaimTenantDTO;
  claimCondominium?: ClaimCondominiumType;
  claimValues: ClaimValueDTO[];
  userId?: string;
};

export const createClaimEstate = async (claim: claimSubmitProps): Promise<any> => {
  const route = `/claims`;
  return await post(route, claim);
};

export const udateClaimEstate = async (
  id: string,
  claim: claimSubmitProps
): Promise<any> => {
  const route = `/claims/${id}`;
  return await put(route, claim);
};

export const deleteClaimDraft = async (id: string): Promise<any> => {
  return await remove(`/claims/${id}`);
};

export const lookupClaimCondominium = async (
  document: string,
  estateId?: string,
  searchAllAccessibleEstates = false
): Promise<LookupClaimCondominiumResponse> => {
  const normalizedDocument = document.replace(/\D/g, '');
  const params = new URLSearchParams({ document: normalizedDocument });
  if (searchAllAccessibleEstates) {
    params.set('searchAllAccessibleEstates', 'true');
  }
  const headers = estateId ? { 'X-Estate-Id': estateId } : {};

  return await get(`/claims/condominiums/lookup?${params.toString()}`, headers);
};
